module.exports = __webpack_public_path__ + "static/media/star.032141fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/star.svg
// module id = 1190
// module chunks = 0